import { render } from "./PhotoGalleryAddPage.vue?vue&type=template&id=61d05498&scoped=true"
import script from "./PhotoGalleryAddPage.vue?vue&type=script&lang=js"
export * from "./PhotoGalleryAddPage.vue?vue&type=script&lang=js"

import "./PhotoGalleryAddPage.vue?vue&type=style&index=0&id=61d05498&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d05498"]])

export default __exports__